<template>
    <div v-if="themeStore.themeIndex == 1">
        <OffersView :data-set="dataSet" />
    </div>
    <div v-if="themeStore.themeIndex == 2">
        <OffersViewTwo :data-set="dataSet" />
    </div>
    <div v-if="themeStore.themeIndex == 3">
        <OffersViewThree :data-set="dataSet" />
    </div>
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
</template>
<script setup lang="ts">
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { getActivityList } from '@/api/offers';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { checkDate, formatUnixTimestamp, getNextDayDate } from '@/utils/commonFunction';
import OffersView from '@/themes/themeOne/offers/offersView.vue';
import OffersViewTwo from '@/themes/themeTwo/offers/offersView.vue';
import OffersViewThree from '@/themes/themeThree/offers/offersView.vue';
import { useThemeStore } from '@/stores/theme';

const themeStore = useThemeStore()
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()

const isActivityEnableTime = ref(false)
const activityList = ref([])
const startTime = ref(0)
const endTime = ref(0)
const claimedDate = ref('')
const days = ref(0)
const hours = ref(0)
const minutes = ref(0)
const seconds = ref(0)
const floatImage = ref("")
let timer: number
const activityIntro = ref([])

const dataSet = computed(() => ({
    isActivityEnableTime: isActivityEnableTime.value,
    activityList: activityList.value,
    startTime: startTime.value,
    endTime: endTime.value,
    claimedDate: claimedDate.value,
    days: days.value,
    hours: hours.value,
    minutes: minutes.value,
    seconds: seconds.value,
    floatImage: floatImage.value,
    activityIntro: activityIntro.value
}))

const setCountdownTarget = (dateStr: string) => {
    // Parse the input date and set target time to 23:59:59
    const target = new Date(`${dateStr}T23:59:59`)
    return target.getTime()
}

const startCountdown = (dateStr: string) => {
    endTime.value = setCountdownTarget(dateStr)
    updateCountdown()
    setInterval(updateCountdown, 1000) // update every second
}

const updateCountdown = () => {
    const now = new Date()
    const diff = endTime.value - now.getTime()

    if (diff <= 0) {
        days.value = hours.value = minutes.value = seconds.value = 0
        return
    }

    const totalSeconds = Math.floor(diff / 1000)
    days.value = Math.floor(totalSeconds / (3600 * 24))
    hours.value = Math.floor((totalSeconds % (3600 * 24)) / 3600)
    minutes.value = Math.floor((totalSeconds % 3600) / 60)
    seconds.value = totalSeconds % 60

}
const getDayNameFromTimestamp = (timestamp: number): string => {
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US", { weekday: "long" });
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const getOfferActivityList = () => {
    loadingRef.value.open()
    getActivityList().then(res => {
        loadingRef.value.close()
        let data = res.data.activity_data
        let activityConfig = JSON.parse(data.activityConfig)
        activityList.value = activityConfig.reward_config
        activityIntro.value = JSON.parse(data.activityIntro)
        let extraConfig = JSON.parse(data?.activityExtra)
        startTime.value = data.startTime
        claimedDate.value = getNextDayDate(extraConfig?.week_day || 0) // 0-mon 1-teu 2-wed 3-thur 4-fri 5-sat 6-sun
        startCountdown(claimedDate.value)
        if (checkDate(claimedDate.value) === 0) {
            isActivityEnableTime.value = true
        } else {
            isActivityEnableTime.value = false
        }

        floatImage.value = data.floatIcon
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

onMounted(() => {

    timer = setInterval(updateCountdown, 1000)
    getOfferActivityList()
})

onUnmounted(() => {
    clearInterval(timer)
})
</script>
<style scoped>
.offers_page {
    padding-top: 50px;
}

.offers_page img {
    width: 100%;
}

.timer {
    padding: 5px 20px;
    position: relative;
}

.timeBox {
    border-radius: 10px;
    padding: 10px;
    background-image: linear-gradient(0deg, #69482a 0%, rgb(43 30 23) 100%);
    border: 1px solid #dd7a33;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
}

.timeTitle {
    color: rgb(246 220 180);
    font-size: 16px;
    font-weight: 900;
    -webkit-text-stroke: 1px rgb(172 74 33);
    display: flex;
    justify-content: center;
}

.timer_countdown {
    font-size: 6vw;
    font-weight: bold;
    color: #000;
    background-image: linear-gradient(0deg, rgb(240, 168, 83) 0%, rgb(248, 216, 167) 100%);
    padding: 5px 20px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-top: 10px;
}

.timer_countdown span {
    color: #FFEE00;
    font-size: 2.8vw;
    background-color: rgba(0, 0, 0, 0.85);
    border-radius: 5px;
    padding: 5px;
    margin: 0 5px;
    font-weight: 200;
}

.promo_wrapper {
    position: relative;
    /* display: inline-block; */
}

.promo_wrapper img {
    width: 100%;
    display: block;
}

.promo_title {
    position: absolute;
    top: 4%;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #993900;
    font-weight: 700;
    font-size: 24px;
    text-shadow: 1px 1px 1px #F0A853;
    z-index: 2;
}

.promotion_card_list {
    position: static;
    margin-top: -120px;
    padding: 0 20px;
}

.bottom_text {
    padding: 25px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px;
}

@media (min-width: 500px) {
    .timer_countdown {
        top: 35px;
        left: 3.6vw;
        font-size: 32px;
        height: 45%;
    }

    .timer_countdown span {
        font-size: 12px !important;
    }
}
</style>